import toastify from "toastify-js"

const getApiErrorMessage = (e, defaultMsg) => {
    if (typeof e === 'string') return e
    if (e && typeof e === 'object' && 'message' in e && typeof e.message === 'string') {
    const errors = e.message.split(' | ')
    const error = errors[0]
    if (typeof error === 'string' && !error.includes('Message: ')) return error
    const msg = error.split('Message: ')[1] ?? defaultMsg
    let path = (error.split('Path: ')[1] ?? '').split(' ~ ')[0]
    path = path.split('body.')[1] ?? path
    path = path
        .split('_')
        .map((str) => (str ? str[0].toUpperCase() + str.slice(1) : ''))
        .join(' ')

    if (path) return `${path} - ${msg}`
    return msg ?? defaultMsg
    }
    return defaultMsg ?? 'Internal server error'
}

const project = 'troller-cat'
const apiFetch = async (url, data) => {
    const fullUrl = url.startsWith('http') ? url : `https://api.trollercat.com/v1${url}`
    const res = await fetch(fullUrl, {
        ...data,
        headers: {
            'Content-Type': 'application/json',
            ...data?.headers
        }
    })
    const json = await res.json()
    if (!res.ok) throw json
    return json
}

export const postLeads = (args) => {
    return apiFetch(`/projects/${project}/leads`, {
        method: 'POST',
        body: JSON.stringify(args)
    })
}

const errorToast = (text) => toastify({
    text: `<svg viewBox="0 0 32 32" width="1.25rem" height="1.25rem" style="overflow: visible;"><circle cx="16" cy="16" r="0" fill="#FF3B30"><animate attributeName="opacity" values="0; 1; 1" dur="0.35s" begin="100ms" fill="freeze" calcMode="spline" keyTimes="0; 0.6; 1" keySplines="0.25 0.71 0.4 0.88; .59 .22 .87 .63"></animate><animate attributeName="r" values="0; 17.5; 16" dur="0.35s" begin="100ms" fill="freeze" calcMode="spline" keyTimes="0; 0.6; 1" keySplines="0.25 0.71 0.4 0.88; .59 .22 .87 .63"></animate></circle><circle cx="16" cy="16" r="12" opacity="0" fill="#FF3B30"><animate attributeName="opacity" values="1; 0" dur="1s" begin="320ms" fill="freeze" calcMode="spline" keyTimes="0; 1" keySplines="0.0 0.0 0.2 1"></animate><animate attributeName="r" values="12; 26" dur="1s" begin="320ms" fill="freeze" calcMode="spline" keyTimes="0; 1" keySplines="0.0 0.0 0.2 1"></animate></circle><path fill="none" stroke-width="4" stroke-dasharray="9" stroke-dashoffset="9" stroke-linecap="round" d="M16,7l0,9" stroke="#FFFFFF"><animate attributeName="stroke-dashoffset" values="9;0" dur="0.2s" begin="250ms" fill="freeze" calcMode="spline" keyTimes="0; 1" keySplines="0.0, 0.0, 0.58, 1.0"></animate></path><circle cx="16" cy="23" r="2.5" opacity="0" fill="#FFFFFF"><animate attributeName="opacity" values="0;1" dur="0.25s" begin="350ms" fill="freeze" calcMode="spline" keyTimes="0; 1" keySplines="0.0, 0.0, 0.58, 1.0"></animate></circle></svg> ${text}`,
    duration: 5000,
    position: "center",
    gravity: "bottom",
    escapeMarkup: false
}).showToast()

const successToast = (text) => toastify({
    text: `<svg viewBox="0 0 32 32" width="1.25rem" height="1.25rem" style="overflow: visible;"><circle cx="16" cy="16" r="0" fill="#34C759"><animate attributeName="opacity" values="0; 1; 1" dur="0.35s" begin="100ms" fill="freeze" calcMode="spline" keyTimes="0; 0.6; 1" keySplines="0.25 0.71 0.4 0.88; .59 .22 .87 .63"></animate><animate attributeName="r" values="0; 17.5; 16" dur="0.35s" begin="100ms" fill="freeze" calcMode="spline" keyTimes="0; 0.6; 1" keySplines="0.25 0.71 0.4 0.88; .59 .22 .87 .63"></animate></circle><circle cx="16" cy="16" r="12" opacity="0" fill="#34C759"><animate attributeName="opacity" values="1; 0" dur="1s" begin="350ms" fill="freeze" calcMode="spline" keyTimes="0; 1" keySplines="0.0 0.0 0.2 1"></animate><animate attributeName="r" values="12; 26" dur="1s" begin="350ms" fill="freeze" calcMode="spline" keyTimes="0; 1" keySplines="0.0 0.0 0.2 1"></animate></circle><path fill="none" stroke-width="4" stroke-dasharray="22" stroke-dashoffset="22" stroke-linecap="round" stroke-miterlimit="10" d="M9.8,17.2l3.8,3.6c0.1,0.1,0.3,0.1,0.4,0l9.6-9.7" stroke="#FCFCFC"><animate attributeName="stroke-dashoffset" values="22;0" dur="0.25s" begin="250ms" fill="freeze" calcMode="spline" keyTimes="0; 1" keySplines="0.0, 0.0, 0.58, 1.0"></animate></path></svg> ${text}`,
    duration: 5000,
    position: "center",
    gravity: "bottom",
    escapeMarkup: false
}).showToast()

const initSignup = () => {
    const signupInputContainers = Array.from(document.querySelectorAll("[data-signup-input]"))
    signupInputContainers.forEach((container) => {
        const input = container.querySelector("input")
        const button = container.querySelector("button")
        if (!input || !button) return
        button.addEventListener("click", async () => {
            if (button.classList.contains("loading")) return
            const email = input.value
            if (!email || !email.includes("@")) return errorToast("Invalid email provided")
            button.classList.add("loading")
            try {
                await postLeads({email})
                successToast("Successfully signed up")
            } catch (err) {
                errorToast(getApiErrorMessage(err))
            }
            button.classList.remove("loading")
        })
    })
}

export default initSignup